import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/loading"
  },
  {//加载页
    path: '/loading',
    name: 'loading',
    component: () => import('../view/loading.vue')
  },
  {//封面
    path: '/cover',
    name: 'cover',
    component: () => import('../view/cover.vue')
  },
  {//查找证件
    path: '/queryId',
    name: 'queryId',
    component: () => import('../view/queryId.vue')
  },

  {//登录
    path: '/login',
    name: 'login',
    component: () => import('../view/login.vue')
  },
  {//注册成功
    path: '/register',
    name: 'register',
    component: () => import('../view/register.vue')
  },
  {//不存在页
    path: '/notFound',
    name: 'notFound',
    component: () => import('../components/notFound.vue')
  },

  {//个人资料
    path: '/personal',
    name: 'personal',
    component: () => import('../view/personal.vue')
  },
  {//票种选择
    path: '/type',
    name: 'type',
    component: () => import('../view/type.vue')
  },
  {//问卷调查
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => import('../view/questionnaire.vue')
  },
  {//预约时间
    path: '/reservation',
    name: 'reservation',
    component: () => import('../view/reservation.vue')
  },
  {//审核
    path: '/examine',
    name: 'examine',
    component: () => import('../view/examine.vue')
  },
  {//完成页单页面
    path: '/complete',
    name: 'complete',
    component: () => import('../view/complete.vue')
  },
  {//完成页单页面
    path: '/end',
    name: 'end',
    component: () => import('../view/end.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../components/404.vue')
  },
  {
    path: '*',
    component: () => import('../components/404.vue')
  }


]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 解决同一页面产生导航冗余，vue-router报错问题
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  if (to.path == '/login' || to.path == '/cover' || to.path == '/loading' || to.path == '/queryId') {
    localStorage.removeItem('token')
  }
  if (to.query.channel) {
    localStorage.setItem('channel', to.query.channel)
  }
  if (to.query.source) {
    localStorage.setItem('source', to.query.source)
  }
  if (sessionStorage.getItem('title')) {
    document.title = sessionStorage.getItem('title')
  }
  if (to.query.display == 0) {
    router.push('/notFound')
    return;
  }
  if (to.path == '/notFound' || to.path == '/404') {
    next()
    return
  }
  if (!to.query.projectId) {
    router.push('/notFound')
    return
  } else {
    sessionStorage.setItem('projectId', to.query.projectId)
  }
  next()

})

export default router
